import { jsx as _jsx } from "react/jsx-runtime";
import { BrandConfigurationProvider } from '@search/core/brands/context';
import { ErrorContainer } from '@search/core/components/ErrorContainer';
import { useI18n } from '@search/core/hooks/useI18n';
import { ErrorBoundary } from 'react-error-boundary';
import { InnerApp } from './InnerApp';
// eslint-disable-next-line @typescript-eslint/no-var-requires,global-require,import/no-dynamic-require
export const { brandConfiguration } = require(`./brands/${process.env.BRAND_ID}`).Configuration;
export const App = () => {
    useI18n();
    return (_jsx(ErrorBoundary, { fallback: _jsx(ErrorContainer, {}), children: _jsx(BrandConfigurationProvider, { config: brandConfiguration, children: _jsx(InnerApp, {}) }) }));
};
